<template>
  <div v-show="visible" class="noticePopover">
    <div class="header">
      <div class="header_icon_section">
        <span class="el-icon-bell header_icon"></span>
      </div>
      <div class="header_title">您有一条重要公告未读</div>
    </div>
    <div class="content">
      <div class="content_title">{{ form.title }}</div>
      <div class="content_time">发布时间：{{ form.publishTime }}</div>
      <div class="content_content">{{ form.content }}</div>
    </div>
    <div class="footer">
      <div class="footer_later" @click="close">稍后再说</div>
      <div class="footer_view" @click="toNoticeView">立即查看</div>
    </div>
  </div>
</template>

<script>
  import req from '@/utils/request'
  export default {
    name: 'noticePopover',
    data() {
      return {
        visible: false,
        form: {
          announcementId: '',
          title: '',
          publishTime: '',
          content: ''
        }
      }
    },
    methods: {
      async open (notice) {
        this.form.announcementId = notice.announcementId
        this.form.title = notice.title
        this.form.publishTime = notice.publishTime
        this.form.content = notice.contentText
        this.visible = true

        req.post('/announcement/employee/popup-shown', { announcementId: notice.announcementId })
      },
      close () {
        this.visible = false
        this.form = {
          announcementId: '',
          title: '',
          publishTime: '',
          content: ''
        }
      },
      toNoticeView () {
        sessionStorage.setItem('noticeId', this.form.announcementId)
        this.$router.push('/notificationBoard')
        this.close()
      }
    }
  }
</script>

<style lang="less" scoped>
  .noticePopover {
    position: fixed;
    z-index: 99;
    bottom: 24px;
    right: 24px;
    width: 300px;
    background-color: #FFFFFF;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0px 0px 16px 0px rgba(0,0,0,0.12);
  }

  .header {
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 12px;
    width: 100%;
    height: 48px;
    background: linear-gradient( 90deg, #2964AE 0%, #1A8AF4 100%);
  }

  .header_icon_section {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 28px;
    height: 28px;
    background-color: #5886C0;
    border-radius: 50%;
    overflow: hidden;
  }

  .header_icon {
    font-size: 16px;
    color: #FFFFFF;
  }

  .header_title {
    margin: 0 0 0 6px;
    font-weight: 500;
    font-size: 14px;
    color: #FFFFFF;
  }

  .content {
    box-sizing: border-box;
    padding: 12px;
    width: 100%;
  }

  .content_title {
    line-height: 20px;
    font-weight: 600;
    font-size: 14px;
    color: #333333;
  }

  .content_time {
    margin: 2px 0 0 0;
    line-height: 20px;
    font-size: 12px;
    color: #667182;
  }

  .content_content {
    margin: 4px 0 0 0;
    line-height: 20px;
    font-size: 12px;
    color: #333333;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .footer {
    box-sizing: border-box;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 0 12px;
    width: 100%;
    height: 40px;
    background-color: #FAFAFA;
    border-top: 1px solid #EBEAEE;
  }

  .footer_later {
    font-size: 12px;
    color: #667182;
    cursor: pointer;
  }

  .footer_view {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 0 0 12px;
    padding: 0 12px;
    height: 24px;
    font-size: 12px;
    color: #FFFFFF;
    background-color: #1890ff;
    border-radius: 4px;
    cursor: pointer;
  }
</style>
